export async function getSlider(id) {
  try {
    const data = await fetch('/api/common/slider?id=' + id).then(res => res.json());
    return data;
  } catch (error) {
    return {}
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/SliderVIew/actions.js